import { useState, useEffect, useRef } from "react";
import {
  Modal,
  Input,
  Table,
  Button,
  Checkbox,
  notification,
  Form,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getInventories } from "../../../toolkit/slices/inventories/inventorySlice";
import generateMC from "../../../../utils/generateMC";
import generatePC from "../../../../utils/generatePC";
import filterSearch from "../../../../utils/filterSearch";
import discountCalc from "../../../../utils/discountCalc";

const ModalCustom = ({
  ok,
  setOk,
  inventories,
  setInventories,
  setsetSelectedInv,
  proposalId,
  setFetchProp,
  isEditable,
  PR,
  setPR,
  editProposal,
}) => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const [toggle, setToggle] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [allInv, setAllInv] = useState(null);
  const [allInvD, setAllInvD] = useState(null); //D as in Dummy That Keeps the Data unchanged during Filteration
  const [searchText, setSearchText] = useState("");
  const [openInvs, setOpenInvs] = useState(false);
  const dispatch = useDispatch();
  const [edit, setEdit] = useState(editProposal);
  const [editPR, setEditPR] = useState(editProposal);

  let reduxInvs = useSelector((state) => state.inventoriesList.inventories);
  useEffect(() => {
    const filteredInventories = reduxInvs.filter(
      (itemB) => !inventories?.some((itemA) => itemA?.invId === itemB._id)
    );
    const muchFilteredData = filteredInventories.map((ele) => {
      return {
        invId: ele._id,
        locationArea: ele.locations.name,
        width: ele.width,
        height: ele.height,
        Bookings: ele.Bookings,
        rpm: ele.ratePerMonth,
        Illu: ele.Illu,
        mountingCharge: generateMC(
          ele.width,
          ele.height,
          ele.Illu,
          ele?.unit,
          ele?.typeOfMedia?.name
        ),
        printingCharge: generatePC(
          ele.width,
          ele.height,
          ele.Illu,
          ele?.unit,
          ele?.typeOfMedia?.name
        ),
        specialRate: ele.ratePerMonth,
        innovationRate: ele?.innovationRate ? ele?.innovationRate : 0,
        ratePerMonth: ele.ratePerMonth,
        checked: false,
      };
    });
    setAllInv(muchFilteredData);
    setAllInvD(muchFilteredData);
    if (PR) {
      setEditPR(editProposal);
    } else {
      setEdit(editProposal);
    }
  }, [reduxInvs, inventories]);
  const inputRef = useRef(null);

  useEffect(() => {
    if (openInvs) {
      inputRef.current.focus();
    }
  }, [openInvs]);

  const handleCloseProp = () => {
    setOk(false); // Set ok state to false to close the modal
    setEdit(false);
    setIsChanged(false);
    setPR(null);
  };
  const handleCloseAllInv = () => {
    setOpenInvs(false); // Set ok state to false to close the modal
    setAllInv(null);
    setAllInvD(null);
    setSearchText("");
  };

  const handleEdit = (value, id, field) => {
    setInventories((prev) => {
      // Find the index of the inventory item with the given id

      const index = prev.findIndex((item) => item.invId === id);
      // Create a copy of the array
      const updatedInventories = [...prev];

      // Update the value of the specified field in the corresponding inventory item
      updatedInventories[index] = {
        ...updatedInventories[index],
        [field]: value,
      };

      return updatedInventories;
    });
    setIsChanged(true);
  };
  function displayInvs() {
    dispatch(getInventories());
    setToggle((prev) => !prev);
    setOpenInvs(true);
  }
  function handleDelete(id) {
    if (inventories.length == 1) {
      notification.error({ message: "Cant Keep the Proposal Empty!" });
    } else {
      setInventories((prev) => {
        let filteredData = prev.filter((ele) => ele.invId !== id);
        return filteredData;
      });
      setIsChanged(true);
    }
  }

  const handleCheckboxChange = (e, record) => {
    const { checked } = e.target;
    const updatedData = allInvD.map((item) => {
      if (item.invId === record.invId) {
        return { ...item, checked };
      }
      return item;
    });
    setAllInv(updatedData);
    setAllInvD(updatedData);
  };

  const handleOkOfAllInv = () => {
    let data = allInv.filter((ele) => ele.checked);
    setOpenInvs(false);
    if (PR != null) {
      let mod = data.map((prev) => {
        return {
          ...prev,
          mountingCharge: 0,
          specialRate: 0,
          innovationRate: 0,
          printingCharge: 0,
        };
      });
      setInventories((prev) => [...prev, ...mod]);
    } else {
      setInventories((prev) => [...prev, ...data]);
    }
    setIsChanged(true);
  };
  let debounceTimer;

  const handleFilterData = (e) => {
    clearTimeout(debounceTimer);
    setSearchText(e.target.value);
    debounceTimer = setTimeout(() => {
      setAllInv(filterSearch(e.target.value, allInvD));
    }, 500); // Adjust the debounce time as needed (e.g., 300 milliseconds)
  };

  const twoLineColumnTitle = (line1, line2) => (
    <span style={{ display: "inline-block", lineHeight: 1.3, textAlign: "center" }}>
      <span style={{ display: "block" }}>{line1}</span>
      <span style={{ display: "block" }}>{line2}</span>
    </span>
  );

  const specialRateColumnTitle = twoLineColumnTitle("Special rate", "Per Month");
  const mountingChargeColumnTitle = twoLineColumnTitle("Mounting", "Charge");
  const printingChargeColumnTitle = twoLineColumnTitle("Printing", "Charge");

  const columns = edit
    ? [
        // {
        //     title: '_id',
        //     dataIndex: '_id',
        //     key: '_id'
        // },
        {
          title: "Location Area",
          dataIndex: "locationArea",
          key: "locationArea",
        },
        // {
        //   title: "RPM",
        //   dataIndex: "rpm",
        //   key: "rpm",
        //   editable: true,
        //   render: (_, record) => (
        //     <Input
        //       disabled={true}
        //       value={record.rpm}
        //       onChange={(e) => handleEdit(e.target.value, record.invId, "rpm")}
        //     />
        //   ),
        // },
        {
          title: mountingChargeColumnTitle,
          dataIndex: "mountingCharge",
          key: "mountingCharge",
          editable: true,
          render: (_, record) => (
            <Input
              disabled={!edit}
              value={record.mountingCharge}
              onChange={(e) =>
                handleEdit(e.target.value, record.invId, "mountingCharge")
              }
            />
          ),
        },
        {
          title: printingChargeColumnTitle,
          dataIndex: "printingCharge",
          key: "printingCharge",
          editable: true,
          render: (_, record) => (
            <Input
              disabled={!edit}
              value={record.printingCharge}
              onChange={(e) =>
                handleEdit(e.target.value, record.invId, "printingCharge")
              }
            />
          ),
        },
        {
          title: specialRateColumnTitle,
          dataIndex: "specialRate",
          key: "specialRate",
          editable: true,
          render: (_, record) => (
            <Input
              disabled={!edit}
              value={record.specialRate}
              onChange={(e) =>
                handleEdit(e.target.value, record.invId, "specialRate")
              }
            />
          ),
        },
        // {
        //   title: "Innovation Rate",
        //   dataIndex: "innovationRate",
        //   key: "innovationRate",
        //   editable: true,
        //   render: (_, record) => (
        //     <Input
        //       disabled={!edit}
        //       value={record.innovationRate}
        //       onChange={(e) =>
        //         handleEdit(e.target.value, record.invId, "innovationRate")
        //       }
        //     />
        //   ),
        // },
        {
          title: "Discount",
          dataIndex: "discount",
          key: "discount",
          editable: false,
          render: (_, record) => (
            <div
              disabled={!edit}
              value={record.specialRate}
              onChange={(e) =>
                handleEdit(e.target.value, record.invId, "specialRate")
              }
            >
              {discountCalc(record.specialRate, record.rpm)} %
            </div>
          ),
        },
        {
          title: "Action",
          dataIndex: "action",
          key: "action",
          editable: true,
          render: (_, record) => (
            <Button disabled={!edit} onClick={() => handleDelete(record.invId)}>
              Delete
            </Button>
          ),
        },
      ]
    : [
        {
          title: "Location Area",
          dataIndex: "locationArea",
          key: "locationArea",
        },
        {
          title: mountingChargeColumnTitle,
          dataIndex: "mountingCharge",
          key: "mountingCharge",
          editable: true,
          render: (_, record) => (
            <Input
              disabled={!edit}
              value={record.mountingCharge}
              onChange={(e) =>
                handleEdit(e.target.value, record.invId, "mountingCharge")
              }
            />
          ),
        },
        {
          title: printingChargeColumnTitle,
          dataIndex: "printingCharge",
          key: "printingCharge",
          editable: true,
          render: (_, record) => (
            <Input
              disabled={!edit}
              value={record.printingCharge}
              onChange={(e) =>
                handleEdit(e.target.value, record.invId, "printingCharge")
              }
            />
          ),
        },
        {
          title: specialRateColumnTitle,
          dataIndex: "specialRate",
          key: "specialRate",
          editable: true,
          render: (_, record) => (
            <Input
              disabled={!edit}
              value={record.specialRate}
              onChange={(e) =>
                handleEdit(e.target.value, record.invId, "specialRate")
              }
            />
          ),
        },
        {
          title: "Discount",
          dataIndex: "discount",
          key: "discount",
          editable: false,
          render: (_, record) => (
            <div
              disabled={!edit}
              value={record.specialRate}
              onChange={(e) =>
                handleEdit(e.target.value, record.invId, "specialRate")
              }
            >
              {discountCalc(record.specialRate, record.rpm)} %
            </div>
          ),
        },
        {
          title: "Action",
          dataIndex: "action",
          key: "action",
          editable: true,
          render: (_, record) => (
            <Button disabled={!edit} onClick={() => handleDelete(record.invId)}>
              Delete
            </Button>
          ),
        },
      ];

  const components = {
    header: {
      cell: (props) => (
        <th
          {...props}
          style={{
            ...props.style,
            backgroundColor: "#daeffe",
            textAlign: "center",
            verticalAlign: "middle",
          }}
        />
      ),
    },
  };

  const columnsForInvs = [
    // {
    //     title: '_id',
    //     dataIndex: '_id',
    //     key: '_id'
    // },
    {
      title: "Location Area",
      dataIndex: "locationArea",
      key: "locationArea",
    },
    {
      title: "Width",
      dataIndex: "width",
      key: "width",
    },
    {
      title: "Height",
      dataIndex: "height",
      key: "height",
    },
    {
      title: "Illumination",
      dataIndex: "Illu",
      key: "Illu",
    },
    {
      title: "Add",
      dataIndex: "add",
      key: "add",
      render: (_, record) => (
        <Checkbox
          checked={record.checked}
          onChange={(e) => handleCheckboxChange(e, record)}
        />
      ),
    },
  ];

  const EditableCell = ({ value, onChange }) => (
    <Input
      disabled={!edit}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
  function enableEdit() {
    setEdit((prev) => !prev);
  }

  const saveProposalEdit = async () => {
    try {
      await fetchEditProposal();
      setIsChanged(false);
      setOk(false);
      setEdit(false);
    } catch (err) {
      console.error("Error saving proposal edit:", err.message);
    }
  };

  const fetchEditProposal = async () => {
    try {
      const data = {
        id: proposalId,
        proposalInvs: inventories,
        packageRate: PR,
      };

      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/editProposal`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      const responseData = await response.json();

      if (responseData.success) {
        notification.success({ message: responseData.message });
        setFetchProp((prev) => !prev);
      } else {
        console.error("Error editing proposal:", responseData.message);
      }
    } catch (err) {
      console.error("Error fetching proposal:", err.message);
    }
  };

  return (
    <>
      <Modal
        title="Proposal Inventories"
        open={ok}
        width={900}
        onOk={handleCloseProp}
        onCancel={handleCloseProp}
        footer={[
          <Button key="cancel" type="primary" onClick={handleCloseProp}>
            OK
          </Button>,
        ]}
      >
        <div
          className="proposal-view-modal-table"
          style={{ width: "100%", overflow: "auto" }}
        >
          <Table
            components={components}
            dataSource={inventories}
            columns={columns}
            rowKey="invId"
          />
        </div>
        <div style={{ width: "20%" }}>
          {PR != null ? (
            <Form.Item label=" Package Rate">
              <Input
                value={PR}
                disabled={!editPR}
                onChange={(e) => {
                  setIsChanged(true);
                  const inputValue = e.target.value;

                  // Attempt to convert the input value to a number
                  const numericValue = Number(inputValue);

                  // If the converted value is NaN, set PR to 0, otherwise set PR to the numeric value
                  if (isNaN(numericValue)) {
                    setPR(0);
                  } else {
                    setPR(numericValue);
                  }
                }}
              />
            </Form.Item>
          ) : null}
        </div>
        <div>
          {/* {!edit && isEditable && PR == null && <Button onClick={() => enableEdit()}>Edit</Button>} */}
          {(editPR || edit) && isEditable && (
            <Button onClick={() => displayInvs()}>Add Inventory</Button>
          )}
          {(edit || PR != null) && isChanged && (
            <Button
              onClick={() => saveProposalEdit()}
              type="primary"
              style={{ marginLeft: "1rem" }}
            >
              Save
            </Button>
          )}
        </div>
      </Modal>
      <Modal
        title="Choose Inventories"
        open={openInvs}
        onOk={handleOkOfAllInv}
        onCancel={handleCloseAllInv}
        width={900}
      >
        <Input
          ref={inputRef}
          placeholder="Search Any Field"
          value={searchText}
          onChange={(e) => handleFilterData(e)}
        />
        <Table
          components={components}
          dataSource={allInv}
          columns={columnsForInvs}
          rowKey="invId"
        />
      </Modal>
    </>
  );
};

export default ModalCustom;
